<template>
  <div class="commodity-sale-list" data-test="commodity-sale-list">
    <search-filter-new
      :items="searchItems"
      :campus="params.campusList"
      placeholder="请输入学员姓名"
      @onCampus="chooseCampus"
      @onSearch="params.keyword = $event"
      @onBatch="batchDeliver"
    />
    <search-filter-new @change="filterChange">
      <FilterItem 
        :hasFilter="!!params.statusQueryList.length" 
        keyName="statusQueryList"
        :value="params.statusQueryList"
        kind="yq-通用选择" 
        title="状态"
        :list="
        [
          { text: '未发货', value: 1 },
          { text: '已发货', value: 2 },
          { text: '已退费', value: 3 },
          { text: '已结转', value: 4 },
        ]" 
      />
      <div 
        class="shortcut-item has-down-icon" 
        :class="{'has-filter': params.priceItemIds.length}"
        @click="chooseCommodity">
        物品
      </div>
      <sideFilterItem :hasFilter="hasFilter" @clickFilter="openFilter"  />
    </search-filter-new>
    <div class="list-number-line" v-if="listAll.length">
      <div class="add-area__info">购买记录：{{ total }}&emsp;未发货：{{ waitSendCount }}</div>
    </div>
    <vx-list
      enable
      :api="api"
      :params="params"
      @load="onLoad"
      @refresh="getGoodsWriteOffData()"
      ref="vxList"
      class="wrapper"
    >
      <div v-for="(item,index) in listAll" 
        :key="index" 
        class="card flex-between"
        @click.prevent="clickHandler(item)">
        <div class="card-left">
          <div class="item-checked" v-if="isBatch">
            <van-icon
              v-if="ids.includes(item.id)"
              name="checked"
              size="var(--fs-ex1)"
              color="var(--c1)"
            />
            <van-icon 
              v-else 
              name="circle" 
              size="var(--fs-ex1)" 
              color="var(--g5)" />
          </div>
          <div>
            <div class="t1">{{item.studentName}}</div>
            <div class="t2">{{item.goodsName}}<template v-if="item.commodityPriceType==2">·{{item.priceItemNames}}</template></div>
            <div class="c1">校区：{{item.campusName}}</div>
            <div class="c1">购买数量：{{item.quantity}}{{item.unitName}}</div>
            <div class="c1">下单时间：{{item.orderCreateTime | formatDatetime('yyyy-MM-dd hh:mm')}}</div>
          </div>
        </div>
        <div v-if="!isBatch" class="card-right">
          <van-button 
            square round 
            type="primary" 
            size="small" 
            @click.stop="confirmDeliver([item.id])" 
            v-if="item.status==1 && item.isRefund==0 && app.permission.op('commodityWriteOff')">发货</van-button>
          <div v-else>
            <div>{{statusObj[item.status]}}</div>
            <div v-if="item.isRefund==1">{{item.transderStatus==1?'已结转':'已退费'}}</div>
          </div>
        </div>
      </div>
      <van-empty
        image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
        description="暂无物品销售/发货数据"
        v-if="!listAll || (listAll && listAll.length === 0)"
        image-size="128"
        style="padding-top: calc(30%)"
      />
    </vx-list>

    <div class="footer flex-between" v-if="isBatch">
      <div class="choosed-status">
        <div class="checked-nav" :class="{ 'all-checked': checkAll }">
          <van-checkbox
            v-model="checkAll"
            icon-size="var(--fs-lg)"
          />全选
        </div>
        <!-- <span class="choosed-num" >已选:<span>{{ids.length}}</span></span> -->
      </div>

      <van-button
        class="ccbtn"
        square
        round
        block
        @click="cancelBatchDeliver"
        style="margin-right: 8px; padding: 0 12px"
        data-test="commodity-sale-list-multi-cancle"
      >
        取消
      </van-button>
      <van-button
        class="cnbtn"
        square
        round
        block
        type="primary"
        @click="confirmDeliver(ids)"
        style="white-space: nowrap; padding: 0 12px"
      >
        批量发货({{ list.length }}/{{ total }})
      </van-button>

     
    </div>
  </div>
</template>

<script>
import SearchFilterNew from "@x3/vue/comp/search-filter-new.vue";
import FilterItem from '@x3/vue/comp/filter-item.vue';
import sideFilterItem from '@x3/vue/filter-comps/side-filter.vue';
import { openCommodityListFiltrate } from "@teacher/views/base/commodity/filtrate/index.js";

export default {
  name: 'commodity-sale-list',
  data() {
    return {
      pageTitle: '物品销售/发货',
      waitSendCount: 0,
      // 可选数据
      listAll: [],
      total: 0,
      // 选中的id数组
      ids: [],
      // 选中的数组
      list: [],
      isBatch: false,
      statusObj: {
        1: '未发货',
        2: '已发货',
      },
      params: {
        campusIds: [app.teacher.campusId],
        campusList: [app.teacher.campus],
        priceItemIds: [],
        priceItemList: [],
        statusQueryList: [], // 状态 1未发货 2已发货 3已退费 4未发货无退费	
        startDate: '',
        endDate: '',
        keyword: '' //模糊查学员
      },
      api: this.$api.goodsWriteOffPage,
      tempStatusQueryList: [] //点击批量发货的时候临时存储一下状态
    }
  },
  computed: {
    searchItems () {
      let arr = ['campus', 'search'];
      if (app.permission.op('commodityWriteOff')) {
        arr.push('batch');
      }
      return arr;
    },
    hasFilter: function () {
      if (this.params.campusIds.length > 0) {
        return true;
      } else if (this.params.priceItemIds.length > 0) {
        return true;
      } else if (this.params.statusQueryList.length > 0){
        return true;
      } else if (this.params.startDate || this.params.endDate){
        return true;
      } else {
        return false;
      }
    },
    checkAll: {
      get() {
        return this.listAll.length == this.ids.length;
      },
      set(val) {
        if (val) {
          this.ids = this.listAll.map(item => item.id);
          this.list = this.listAll.map(item => item);
        } else {
          this.ids = [];
          this.list = []
        }
      },
    },
  },
  watch: {
    'params.campusIds': {
      handler() {
        this.getGoodsWriteOffData();
      },
    },
    'params.keyword': {
      handler() {
        this.getGoodsWriteOffData();
      },
    },
  },
  methods: {
    filterChange (res) {
      Object.assign(this.params, res)
    },
    onLoad(list, res) {
      vant.Toast.clear();
      this.listAll = list;
      this.total = res.page.totalCount;
    },
    // 选择物品
    async chooseCommodity() {
      let res = await app.x3.side.xsGoods({
        ids: this.params.priceItemIds,
        list: this.params.priceItemList,
        params: {
          campusIds: this.params.campusIds,
          campusList: this.params.campusList,
        },
        config: {
          id_key: 'priceItemId',
          show_price: true
        }
      });
      this.params.priceItemIds = res.ids;
      this.params.priceItemList = res.list;
    },
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList
      });
      this.params.campusIds = res.ids;
      this.params.campusList = res.list;
    },
    async openFilter() {
      let res = await openCommodityListFiltrate({
        params: {
          // campusIds: this.params.campusIds,
          // campusList: this.params.campusList,
          // priceItemIds: this.params.priceItemIds,
          // priceItemList: this.params.priceItemList,
          ...this.params,
          commoditySaleStatus: this.params.statusQueryList,
          commoditySalePayStartDate: this.params.startDate,
          commoditySalePayEndDate: this.params.endDate,
        },
        config: {
          enableCommodityFilter: true,
          enableCommoditySaleStatusFilter: this.isBatch ? false : true,
          enableCommoditySalePayFilter: true,
        }
      });
      this.showLoading();
      this.params.campusIds = res.params.campusIds;
      this.params.campusList = res.params.campusList;
      this.params.priceItemIds = res.params.priceItemIds;
      this.params.priceItemList = res.params.priceItemList;
      this.params.statusQueryList = res.params.commoditySaleStatus;
      this.params.startDate = res.params.commoditySalePayStartDate;
      this.params.endDate = res.params.commoditySalePayEndDate;
      this.getGoodsWriteOffData();
    },
    goDetail(item) {
      this.$router.push(`/commoditySaleDetail/${item.id}`)
    },
    batchDeliver() {
      this.isBatch = true;
      this.showLoading();
      this.tempStatusQueryList = this.params.statusQueryList;
      this.params.statusQueryList = [5];
    },
    cancelBatchDeliver() {
      this.isBatch = false;
      this.showLoading();
      this.params.statusQueryList = this.tempStatusQueryList;
    },
    confirmDeliver(ids) {
      if (ids.length == 0) {
        this.$toast.fail('请选择要发货的记录');
        return;
      }
      this.$dialog.confirm({
        title: "提示",
        message: '是否将销售记录标记为已发货？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(res => {
        this.showLoading();
        this.$api.goodsWriteOffWriteOff({
          ids: ids
        }).then(res=> {
          this.$toast.clear();
          if (res.code===200) {
            this.$toast.success('已标记发货');
            this.cancelBatchDeliver();
            this.getGoodsWriteOffData();
            this.$refs.vxList.refresh();
          } else{
            this.$toast.fail(res.msg);
          }
        });
      });
    },
    clickHandler(item) {
      if (this.isBatch) {
        if (this.ids.includes(item.id)) {
          let idx = this.ids.indexOf(item.id);
          this.ids.splice(idx, 1);
          this.list.splice(idx, 1);
        } else {
          this.ids.push(item.id);
          this.list.push(item);
        }
      } else {
        this.goDetail(item);
      }
    },
    getGoodsWriteOffData() { // 获取未发货数量
      this.$api.goodsWriteOffData(this.params).then(res=>{
        if (res.code == 200) {
          this.waitSendCount = res.data.waitSendCount;
        } else {
          this.$toast.success(res.msg);
        }
      })
    }
  },
  created() {
    this.showLoading();
    this.getGoodsWriteOffData();
    this.$onBus('refresh-commodity-sale-list', () => {
      this.showLoading();
      this.$refs.vxList.refresh();
      this.getGoodsWriteOffData();
    });
  },
  components: {
    SearchFilterNew,
    FilterItem,
    sideFilterItem,
  }
}
</script>

<style lang="scss" scoped>
.commodity-sale-list {
  display: flex;
  flex-direction: column;
  .wrapper {
    flex: 1;
    overflow: auto;
    .card {
      margin:  0 calc(var(--gap) * 16) calc(var(--gap) * 12);
      padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
      border-radius: var(--radius-sm);
      background-color: var(--white);
      .card-left {
        flex: 1;
        display: flex;
        .item-checked {
          margin-right: calc(var(--gap) * 16);
          width: calc(var(--w) * 16);
          height: calc(var(--w) * 16);
        }
        .t1 {
          margin-bottom: calc(var(--gap) * 4);
          font-size:var(--fs-lg);
          line-height:var(--lh-lg);
          color: var(--g8);
          font-weight: var(--bold);
        }
        .t2 {
          font-size:var(--fs-md);
          line-height:var(--lh-md);
          color: var(--g7);
        }
        .c1 {
          margin-top: calc(var(--gap) * 8);
          font-size:var(--fs-sm);
          line-height:var(--lh-sm);
          color: var(--g6);
        }
      }
      .card-right {
        flex-shrink: 0;
        color: var(--g7);
        font-size:var(--fs-md);
        line-height:var(--lh-md);
      }
    }
  }
  .footer {
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .van-button {
      min-width: 20px;
      height: calc(var(--w) * 40);
      padding: 0 8px;
    }
    .ccbtn {
      flex: 2;
    }
    .cnbtn {
      flex: 5;
    }
    .choosed-status {
      flex: 1;
      white-space: nowrap;
      margin-right: calc(var(--gap) * 16);

      .checked-nav {
        margin-right: calc(var(--gap) * 16);
        display: flex;
        align-items: center;
        color: var(--g6);
        > div {
          margin-right: calc(var(--gap) * 4);
        }
        &.all-checked {
          color: var(--g8);
        }
      }
    }
  }
}
</style>